module.exports = __webpack_public_path__ + "img/plat.a7b7dcab.png";